import types from './types'

export default {
  [types.getters.GET_SELECTED_DATE]: (state) => () => {
    return state.selectedDate;
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js